import styled from "styled-components"

export const ContentSideBar = styled.div`
  .side-bar-text {
    width: 295px;
    max-width: 295px;
    background-color: red ;
    font-size: 20rem;
  }
`